import { useExternalUsersSaqDashboardJob } from 'src/hooks/dashboard';
import { tryCall } from 'src/utils/core/functions';

export default () => {
  const { data: Saqjobs, loading: SaqjobsLoading, refetch: reFetchSAQJobs } = tryCall(() => useExternalUsersSaqDashboardJob(), { data: [], loading: false });

  const reFetchNextSAQJobsBatch = (offset) => {
    reFetchSAQJobs({ limit: 18, offset });
  };

  return {
    Saqjobs: (Saqjobs && Saqjobs.saqJobsDashboard) || [],
    totalSAQJobs: (Saqjobs && Saqjobs.saqJobsDashboardPageInfo.totalCount) || 0,
    reFetchNextSAQJobsBatch,
    SaqjobsLoading,
  };
};
